<div *ngIf="renderizado" [ngClass]="this.classFont">
<!-- Top Bar -->
<app-header [configuracion]="configuracion"></app-header>
<!-- #Top Bar -->
<!-- Main Container -->
<div class="container main-container mt-contenido">
  <router-outlet></router-outlet>
</div>
<!-- #Main Container -->
<!-- Footer Bar -->
<app-footer></app-footer>
<!-- #Footer Bar -->
  <!--app-chat-component></!--app-chat-component-->

<!--app-avisos-ciudadano #avisoModal [aviso]="aviso"></°app-avisos-ciudadano-->
</div>
